import { firebase } from "../config/firebase.client";
import { onValue, set, push, update, remove, child } from "firebase/database";
import { FETCH_ALL_PANICS, FETCH_ALL_PANICS_SUCCESS, FETCH_ALL_PANICS_FAILED, EDIT_PANICS } from "../store/types";
import { IPanicType } from "../types";


export const fetchPanic = () => (dispatch: any) => {
  const { panicAddRef } = firebase;

  dispatch({
    type: FETCH_ALL_PANICS,
    payload: null,
  });

  onValue(panicAddRef, (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map((i) => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_PANICS_SUCCESS,
        payload: arr.reverse(),
      });
    } else {
      dispatch({
        type: FETCH_ALL_PANICS_FAILED,
        payload: "No Panic available.",
      });
    }
  });
};

export const completePanic = (panic: IPanicType) => (dispatch: any) => {
  if (!panic.id) return;

  const { panicAddRef } = firebase;

  update(child(panicAddRef, panic.id), {
    ...panic,
    processed: true,
    processDate: new Date().getTime(),
  });

  dispatch({
    type: FETCH_ALL_PANICS,
    payload: null,
  });
};

export const editPanic = (panic: IPanicType, method: "Add" | "Delete" | "Edit") => async (dispatch: any) => {
  if (!panic.id) return;

  const { panicAddRef, panicEditRef } = firebase;

  dispatch({
    type: EDIT_PANICS,
    payload: { method, panic },
  });

  if (method === "Add") {
    push(panicAddRef, panic);
  } else if (method === "Delete") {
    remove(panicEditRef(panic.id));
  } else {
    set(panicEditRef(panic.id), panic);
  }
};
